import { TypedSopNode } from "./_Base";
import { RoundedBoxSopOperation } from "../../operations/sop/RoundedBox";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
const DEFAULT = RoundedBoxSopOperation.DEFAULT_PARAMS;
class RoundedBoxSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.size = ParamConfig.VECTOR3(DEFAULT.size);
    this.divisions = ParamConfig.INTEGER(DEFAULT.divisions, {
      range: [1, 10],
      rangeLocked: [true, false]
    });
    this.bevel = ParamConfig.FLOAT(DEFAULT.bevel, {
      range: [0, 1],
      rangeLocked: [true, false]
    });
    this.center = ParamConfig.VECTOR3(DEFAULT.center);
  }
}
const ParamsConfig = new RoundedBoxSopParamsConfig();
export class RoundedBoxSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "roundedBox";
  }
  static displayedInputNames() {
    return ["geometry to create bounding box from (optional)"];
  }
  initializeNode() {
    this.io.inputs.setCount(0, 1);
    this.io.inputs.initInputsClonedState(RoundedBoxSopOperation.INPUT_CLONED_STATE);
  }
  cook(input_contents) {
    this._operation = this._operation || new RoundedBoxSopOperation(this._scene, this.states);
    const core_group = this._operation.cook(input_contents, this.pv);
    this.setCoreGroup(core_group);
  }
}
